import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchSystemParameters = (parameters = {}) => {
  const urlParams = getUrlParameters(parameters);

  return apiActionCreator({
    'endpoint': `/parameters/system${urlParams}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_SYSTEM_PARAMETERS,
      ActionTypes.FETCHED_SYSTEM_PARAMETERS,
      [
        ActionTypes.FETCHED_SYSTEM_PARAMETERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchSystemParameter = (code) => apiActionCreator({
  'endpoint': `/parameters/system/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SYSTEM_PARAMETER,
    ActionTypes.FETCHED_SYSTEM_PARAMETER,
    [
      ActionTypes.FETCHED_SYSTEM_PARAMETER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const updateSystemParameter = (code, parameterData) => apiActionCreator({
  'endpoint': `/parameters/system/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.UPDATING_SYSTEM_PARAMETER,
    [
      ActionTypes.UPDATED_SYSTEM_PARAMETER,
      MessageActions.addMessageBoxInfo('Parámetro actualizado satisfactoriamente'),
    ],
    [
      ActionTypes.UPDATED_SYSTEM_PARAMETER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': parameterData,
});

export const createSystemParameter = (parameterData) => apiActionCreator({
  'endpoint': '/parameters/system',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_SYSTEM_PARAMETER,
    [
      ActionTypes.CREATED_SYSTEM_PARAMETER,
      MessageActions.addMessageBoxInfo('Parámetro creado satisfactoriamente'),
    ],
    [
      ActionTypes.CREATED_SYSTEM_PARAMETER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': parameterData,
});

export const deleteParametersData = () => ({
  'type': ActionTypes.DELETE_SYSTEM_PARAMETERS_DATA,
});
